import React from 'react';
import ModernWordCloud from './ModernWordCloud';

// MD3 token mapping roughly to array
const COLORS = [
    '#009640', // Primary
    '#507356', // Secondary
    '#a5693a', // Tertiary
    '#386567', // Custom
    '#6750a4'  // Custom
];

const WordCloudDisplay = ({ content }) => {
    if (!content || !Array.isArray(content.words) || content.words.length === 0) return null;

    return (
        <div className="p-6 md:p-8 rounded-xl border border-outlineVariant bg-surface text-surface-on shadow-sm">
            {content.title && (
                <h3 className="text-headline-small font-bold mb-6 text-surface-on">
                    {content.title}
                </h3>
            )}
            <div className="w-full h-[300px] rounded-2xl overflow-hidden bg-surface-containerLow p-6 border border-outlineVariant relative">
                <ModernWordCloud 
                    words={content.words} 
                    colors={COLORS}
                />
            </div>
        </div>
    );
};

export default WordCloudDisplay;
